import EditPaddingPopover from './EditPaddingPopover';

export default EditPaddingPopover;
